export enum LanguageCode {
    default='en',
    en='en',
    de='de',
    pl='pl',
    fr='fr',
    es='es',
    nl='nl'
}